import { useEffect, useRef } from 'react'
import { useChurch } from './useChurch'
import { applyChurchColors, getChurchColorClasses, removeChurchColors } from '@/lib/colors'

/**
 * Hook para usar as cores da igreja nos componentes
 * Aplica automaticamente as variáveis CSS customizadas
 */
export function useChurchColors() {
  const { primaryColor, secondaryColor, titleColor, descriptionColor, loading, revalidate } = useChurch()
  const colorsAppliedRef = useRef(false)

  // Aplica as cores como variáveis CSS quando carregadas
  useEffect(() => {
    console.log('🏛️ useChurchColors - Cores recebidas:', { primaryColor, secondaryColor, titleColor, descriptionColor, loading })
    
    if (!loading && primaryColor && secondaryColor && !colorsAppliedRef.current) {
      console.log('🎯 Aplicando cores da igreja...')
      applyChurchColors(primaryColor, secondaryColor)
      colorsAppliedRef.current = true
    } else {
      console.log('⚠️ Cores não disponíveis ainda ou já aplicadas')
    }

    // Cleanup apenas quando o componente raiz é desmontado
    // Não remove as cores a cada navegação para evitar flickering
  }, [primaryColor, secondaryColor, titleColor, descriptionColor, loading])

  // Gera as classes CSS dinâmicas
  const colorClasses = getChurchColorClasses(primaryColor, secondaryColor)

  return {
    primaryColor,
    secondaryColor,
    titleColor,
    descriptionColor,
    loading,
    colorClasses,
    // Funções utilitárias
    applyColors: () => applyChurchColors(primaryColor, secondaryColor),
    removeColors: removeChurchColors,
    revalidate,
  }
}